import { useMemo } from 'react';
import { pick } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

export const useAddressLookupSwissConfig = () => {
    const {
        isPostcodeEnabled,
        postcodeConfiguration,
        postcodeProvider
    } = useAppSelector(pick([
        'isPostcodeEnabled',
        'postcodeConfiguration',
        'postcodeProvider'
    ]));

    const url = 'reverseProxyURL' in postcodeConfiguration ? postcodeConfiguration?.reverseProxyURL : '';
    const isEnabled = isPostcodeEnabled
        && postcodeProvider === 'Swiss'
        && url;

    return useMemo(() => ({
        isEnabled,
        url
    }), [
        isEnabled,
        url
    ]);
};
